import { render, staticRenderFns } from "./MainContentIntegrations.vue?vue&type=template&id=321022aa&lang=pug"
import script from "./MainContentIntegrations.vue?vue&type=script&lang=js"
export * from "./MainContentIntegrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports